import { APP_LANGUAGES } from 'src/constants';

export const dumpSelectedApp = (data) => {
  const payload = { ...data };
  const translations = {};

  for (const item of data.translations) {
    translations[item.lang] = { ...item };
  }

  for (const language of APP_LANGUAGES) {
    if (!data.translations.find((item) => item.lang === language)) {
      translations[language] = {
        title: '',
        shortDescription: '',
        longDescription: ''
      };
    }
  }

  payload.translations = translations;

  return payload;
};
